import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", (event) => {
    banner();
    projectGroupInit();
});

function banner(){
    const progressCircle = document.querySelector(".autoplay-progress svg");
    const progressContent = document.querySelector(".autoplay-progress span");
    const bannerSwiper = new Swiper(".bannerSwiper", {
        effect: "fade",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                progressCircle.style.setProperty("--progress", 1 - progress);
                progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            }
        }
    });
}


function projectGroupInit() {
    let projectGroups = document.querySelectorAll('.projects-group');
    projectGroups.forEach((element, index) => {
        let projectGroupSwiperElm = element.querySelector('.projectGroupSwiper');
        let swiperButtonNext = element.querySelector('.projectGroupSwiper-next');
        let swiperButtonPrev = element.querySelector('.projectGroupSwiper-prev');

        // Calculate a unique delay for each swiper based on its index
        let delay = 2500 + index * 500; // Starting from 2500ms, adding 500ms for each next swiper

        let projectGroupSwiper = new Swiper(projectGroupSwiperElm, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
            },
            autoplay: {
                delay: delay, // Unique delay for this swiper
                disableOnInteraction: false,
            },
            speed: 2000,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
        });
    });
}